import Vuex from 'vuex'
import axios from 'axios'
import Vue from 'vue'

Vue.use(Vuex);


export default new Vuex.Store({
    install(Vue, options){
        function getCsrfToken(){
            const cookies = document.cookies.split(';');
            for(let i = 0; i < cookies.length; i++){
                const cookie = cookies[i].trim();
                if(cookie.startWith('XSRF-TOKEN')){
                    return cookie.substring('XSRF-TOKEN='.length, cookie.length);
                }
            }
            return null;
        }
        Vue.prototype.$addCsrfTokenToHeaders = function(headers){
            const csrfToken = getCsrfToken();
            if(csrfToken){
                headers['X-XSRF-TOKEN'] = csrfToken;
            }
            return headers;
        };
    },
    state: {
        idToken: sessionStorage.getItem('access_token') || null,
        lastActivityTime : sessionStorage.getItem('lastActivityTime')||null,
        csrfToken: null,
    },
    getters: {
        loggedIn(state) {
            return state.idToken != null;
        },
    },
    mutations: {
        RetriveToken(state, token) {
            state.idToken = token;
        },
        setLastActivityTime(state, time){
            state.lastActivityTime = time;
        },
        setCsrfToken(state, token){
            state.csrfToken = token;
        },
        logout(state) {
            state.idToken = null;
            state.lastActivityTime=null;
            sessionStorage.removeItem('access_token');
            sessionStorage.removeItem('refresh_token');
            sessionStorage.removeItem('loginTimestamp');
        },
    },
    actions: {
        RetriveToken(context, credentials) {
            //axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
            // Add SameSite attribute to the CSRF token header
            axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";        
            delete axios.defaults.headers.common["Authorization"];
            return new Promise((resolve, reject) => {
                //console.log("creden",credentials);
                axios.post('/api/v1/auth/authenticate', credentials)
                    .then( async response => {
                        //console.log("some",response);
                        if(response.data.token){
                            sessionStorage.setItem("access_token", response.data.token.access);
                            sessionStorage.setItem("refresh_token", response.data.token.refresh);
                            sessionStorage.setItem("csrfToken", response.data.csrfToken,"SameSite=Strict");
                            sessionStorage.setItem("ID", response.data.user.ownedBy);
                            sessionStorage.setItem("userID", response.data.user.id);
                            sessionStorage.setItem("userRole", response.data.user.role);
                            sessionStorage.setItem("mainRole", response.data.user.mainRole);
                            sessionStorage.setItem("lastActivityTime",Date.now());
                            
                            // Force refresh cache by setting timestamp
                            sessionStorage.setItem("loginTimestamp", Date.now());

                            var modules = "";
                            await response.data.modules.forEach((element, idx, array) => {
                                if(idx === array.length - 1 ){
                                    if(element.listData == 1){
                                        modules += element.name;
                                    }
                                }else{
                                    if(element.listData == 1){
                                        modules += element.name + ",";
                                    }
                                }
                            });
                            sessionStorage.setItem("modules", modules)
                        }else{
                            sessionStorage.setItem("ID", response.data.userId);
                        }
                        // sessionStorage.setItem("role", response.data.role);
                       // sessionStorage.setItem("fullname", response.data.fullname);
                        resolve(response);
                    })
                    .catch(error => {
                        //console.log(error);
                        reject(error);
                    })
            })
        },
        // GetCsrfToken(context, token){
        //     delete axios.defaults.headers.common["Authorization"];
        //     return new Promise((resolve, reject) => {
        //         //console.log("creden",credentials);
        //         axios.post('/get/token', credentials)
        //             .then( async response => {
        //                 context.commit('setCsrfToken', response.data.token);
        //                 resolve(response);
        //                 sessionStorage.setItem("csrfToken", response.data.token);
        //             })
        //             .catch(error =>{
        //                 reject(error);
        //             })
        //         })
        // },
        // async GetCsrfToken({ commit }) {
        //     try {
        //         const api = axios.create({
        //             baseURL: 'http://10.6.14.31:9092/',
        //         });
        //       const response = await api.post('/get/token');
        //       commit('setCsrfToken', response.data.token);
        //       console.log('CSRF token received:', response.data.token);
        //       return response;
        //     } catch (error) {
        //       console.error('Error fetching CSRF token:', error);
        //       throw error;
        //     }
        // },
        async GetCsrfToken(context){
            return new Promise(async (resolve, reject) =>{
            await axios.get('/get/token', { refresh_token: sessionStorage.getItem('refresh_token')})
              .then(response => {
                console.log('CSRF token received:', response.data.token);
                sessionStorage.setItem('csrf_token',  response.data.token,"SameSite=Strict");
                context.commit('RetriveToken', response.data.token);
                resolve(response);
              })
              .catch(error => {
                console.log(error);
                reject(error);
              })
            })
          },        
        logout(context){
            return new Promise((resolve) => {
                context.commit('logout');
                sessionStorage.removeItem('access_token');
                sessionStorage.removeItem('refresh_token');
                resolve();
            });
        },
        async renewAccessToken(context){
            return new Promise(async (resolve, reject) =>{
            await axios.post('/api/v1/auth/refresh', { refresh_token: sessionStorage.getItem('refresh_token')})
              .then(response => {
                sessionStorage.setItem('access_token',  response.data.access_token);
                sessionStorage.setItem('refresh_token', response.data.refresh_token);
                context.commit('RetriveToken', response.data.access_token);
                resolve(response);
              })
              .catch(error => {
                //console.log(error);
                reject(error);
              })
            })
          },
        Logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit('Logout')
                sessionStorage.removeItem('access_token')
                sessionStorage.removeItem('refresh_token')
                // sessionStorage.removeItem('role')
                // sessionStorage.removeItem('branch')
                // sessionStorage.removeItem('ID')
                delete axios.defaults.headers.common['Authorization']
                if (!sessionStorage.getItem('access_token')) resolve("successfully signed out")
                else reject("problem on destroying token");
            })
        },
        changePassword(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/password/change/not/token', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        changePasswordAtLogin(context, user){
            delete axios.defaults.headers.common["Authorization"];
            // axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/password', user)
                .then(async response=>{
                    //console.log("change", response);
                    if(response.data.token){
                            sessionStorage.setItem("access_token", response.data.token.access);
                            sessionStorage.setItem("refresh_token", response.data.token.refresh);
                            sessionStorage.setItem("ID", response.data.user.ownedBy);
                            sessionStorage.setItem("userID", response.data.user.id);

                            var modules = "";
                            await response.data.modules.forEach((element, idx, array) => {
                                if(idx === array.length - 1 ){
                                    if(element.listData == 1){
                                        modules += element.name;
                                    }
                                }else{
                                    if(element.listData == 1){
                                        modules += element.name + ",";
                                    }
                                }
                            });
                            sessionStorage.setItem("modules", modules)
                        }else{
                            sessionStorage.setItem("ID", response.data.userId);
                        }
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        resetPassword(context, user){
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/reset', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getBuildingsByOwnerID(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/building/users', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },

        getAllBuildingsList(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/building/all/building', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        getOneBuildingsByID( context  , buildingId) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('access_token');
            
            return new Promise((resolve, reject) => {
              axios.post('/list/building/get/1', buildingId)
                .then(response => {
                  resolve(response);
                })
                .catch(error => {
                  reject(error.response);
                });
            });
          },
          // Other actions can go here
        getAllBuildings(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/building/buildings', userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        getBuildingById(context, buildingId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/building/get/1', buildingId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    //console.log("Error:", error)
                    reject(error.response);
                })
            })
        },
        AddBuilding(context,Building){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/building', Building)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getHouseByOwnerID(context,user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/users',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllHouseList(context,user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/all/house',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getHouseById(context,user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/get/1/house',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllHouses(context,user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/houses',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getFreeHousesByOwnerID(context,user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/free/houses',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddHouse(context,House){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house', House)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getDetailTenant(context,tenant){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/renter/detail/info',tenant)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getTenantByOwnerID(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/renter/users',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAllTenantList(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/renter/all/tenant',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddTenant(context,Tenant){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/renter', Tenant)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getContractByOwnerID(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/users/enable',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getContractByOwnerIDandDate(context,user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/filter/by/endDate',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getDisabledContractByOwnerIDandDate(context,user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/disable/list/filter/by/date',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getDisabledContractByOwnerID(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/users/disable',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },

        filterContractByContractID(context,Contract){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/filter/by/contractId', Contract)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },

        getAllPaymentsList(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/payment/view/all/list',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },

        getPaymentsByOwnerID(context,userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/payment/view/users',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaidAmountAndList(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            //axios.defaults.headers.common['X-CSRF-TOKEN'] =  sessionStorage.getItem('csrfToken');
            axios.defaults.headers.common["X-XSRF-TOKEN"]=sessionStorage.getItem('csrf_token');
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/check/paid',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUnPaidAmountAndList(context, userId){
            //console.log("here1", userId);
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            //axios.defaults.headers.common['XSRF-TOKEN'] =  sessionStorage.getItem('csrfToken')
            axios.defaults.headers.common["X-XSRF-TOKEN"]=sessionStorage.getItem('csrf_token');
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/check/unpaid',userId)
                .then(response=>{
                    //console.log("here", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getOverdueListAndTotalAmount(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token');
            axios.defaults.headers.common['XSRF-TOKEN'] =  sessionStorage.getItem('csrfToken');
            axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
            // Add SameSite attribute to the CSRF token header
            axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";       
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/check/overdue',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getMonthlyTotalIncome(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
            // Add SameSite attribute to the CSRF token header
            axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";        
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/monthly/paid',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaidAmountAndListOwner(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            //axios.defaults.headers.common['X-CSRF-TOKEN'] =  sessionStorage.getItem('csrfToken');
            axios.defaults.headers.common["X-XSRF-TOKEN"]=sessionStorage.getItem('csrf_token');
            return new Promise((resolve, reject) => {
                axios.post('/owner/payment/calculate/paid/this/month',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUnPaidAmountAndListOwner(context, userId){
            //console.log("here1", userId);
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            //axios.defaults.headers.common['XSRF-TOKEN'] =  sessionStorage.getItem('csrfToken')
            axios.defaults.headers.common["X-XSRF-TOKEN"]=sessionStorage.getItem('csrf_token');
            return new Promise((resolve, reject) => {
                axios.post('/owner/payment/calculate/unpaid/this/month',userId)
                .then(response=>{
                    //console.log("here", response);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getOverdueListAndTotalAmountOwner(context, userId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token');
            axios.defaults.headers.common['XSRF-TOKEN'] =  sessionStorage.getItem('csrfToken');
            axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
            // Add SameSite attribute to the CSRF token header
            axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";       
            return new Promise((resolve, reject) => {
                axios.post('/owner/payment/calculate/overdue/this/month',userId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getMonthlyTotalIncomeOwner(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
            // Add SameSite attribute to the CSRF token header
            axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";        
            return new Promise((resolve, reject) => {
                axios.post('/owner/payment/payment/year/of/month',user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        ChangePrice(context, price){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/housePrice',price)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        ChangeBills(context, bills){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/bill/price/change',bills)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        ChangeBillsByReading(context, bills){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/change/reading/water/electric',bills)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        ChangeBillsOfInternetAndOther(context, bills){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/bill/price/change/otherprice',bills)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddBillsForBuilding(context, bills){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/change/bills/for/building',bills)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        EditHouse(context, house){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/update',house, 
                house
                )
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        GetHouseDetailById(context, house){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/detail/info', house)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        EditBuilding(context, building){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.put('/list/building/update', building)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        EditTenant(context, tenant){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/renter/update', tenant)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddFamily(context, tenant){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/add/family', tenant)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        GetContractDetailById(context, contract){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/more/info', contract)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        EditContract(context, contract){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.put('/list/contract/'+contract.contractId, contract)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getAccountByID(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/get/byId', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        GetContractFile(context, file){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/encode', file)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPaymentsByOwnerIDAndDate(context, Date){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/payment/view/filter/date', Date)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getModulesPermission(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/role/module/user-details', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getUsersByOwnerID(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/owner/users', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddUsers(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/register', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddUsersForCollectors(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/register/for/collector', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getModulesList(context){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.get('/role/module/module')
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        AddModuleAndPermission(context, module){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/add/module/user', module)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        UpdateModuleAndPermission(context, module){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/update/module/permission', module)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        DeleteModuleandPermissionForUser(context, module){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/delete/module', module)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        LockUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/lock', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        CreateContractMerged(context, contractData){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/create/all/in/one', contractData)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        UnlockUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/unlock', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        UpdateUser(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/update', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        UpdateUserCollector(context, user){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/api/v1/auth/update/for/collector', user)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getBillsByHouseID(context, house){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/bill/price/get/by/house', house)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getBillsByHouseIDStatus1(context, house){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/bill/price/get/by/house/status/1', house)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getPricesByHouseID(context, house){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/house/get/latest/price/data', house)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReports(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/report/get', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        // getReports(context, report){
        //     axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        //     return new Promise((resolve, reject) => {
        //         axios.post('/report/filter/by/building/status', report)
        //         .then(response=>{
        //             resolve(response);
        //         })
        //         .catch(error => {
        //             reject(error);
        //         })
        //     })
        // },
        getReportsByBuildingandStatusandDate(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/report/filter/by/building/status/date', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByDate(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/report/filter/by/contract/date', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByBuilding(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/report/filter/by/building', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByBuildingandDate(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/report/filter/by/building/date', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByStatusandDate(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/report/filter/by/status/date', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getReportsByBuildingandStatus(context, report){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/report/filter/by/building/status', report)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        GetContractByID(context, contractId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/disable/query', contractId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        disableContract(context, contractId){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/disable', contractId)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        enableContract(context, contract){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/enable/contract/as/new', contract)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        getBillsByBuildingId(context, contract){
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
            return new Promise((resolve, reject) => {
                axios.post('/list/contract/enable/contract/as/new', contract)
                .then(response=>{
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
    getOverdueContractNotification(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token');
        axios.defaults.headers.common['XSRF-TOKEN'] =  sessionStorage.getItem('csrfToken');
        axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
        // Add SameSite attribute to the CSRF token header
        axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";      
        return new Promise((resolve, reject) => {
            axios.post('/list/contract/overdue/notification', ID)   
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getOverdueContractNotificationOwner(context, ID){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token');
        axios.defaults.headers.common['XSRF-TOKEN'] =  sessionStorage.getItem('csrfToken');
        axios.defaults.headers.common["X-CSRF-TOKEN"] = sessionStorage.getItem('csrf_token');
        // Add SameSite attribute to the CSRF token header
        axios.defaults.headers.common["Cookie"] = "csrf_token=" + sessionStorage.getItem('csrf_token') + "; SameSite=Strict";      
        return new Promise((resolve, reject) => {
            axios.post('/house/owner/overdue/notification', ID)   
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    AddProperty(context, property){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/add/house/property', property)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    UpdateProperty(context, property){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.put('/update/property/'+property.id, property)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getOneProperty(context, property){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.put('/get/latest/'+property.id)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },


    getOwnersByUser(context, property){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/owner/list/by/user', property)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    AddOwner(context, property){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/owner/register', property)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    EditOwner(context, property){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/owner/edit', property)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    editOwnership(context, property){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/house/owner/edit', property)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    registerOwnerOfHouse(context, ownership){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/house/owner/link', ownership)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    listOwnerAndHouseInfoByUser(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/house/owner/list/by/user', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getHousesByUser(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/list/house/users', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getBuildingsByUser(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/list/building/users', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getFreeOwnershipByOwnerID(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/list/house/free/ownership', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    listOwnerAndHouseInfoByUser(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/house/owner/list/by/user', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getPaymentsByHouseOwner(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/owner/payment/history', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getHouseOwnerReport(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/house/owner/report', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },

    createReadingConfig(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/meter/reading/add', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    updateReadingConfig(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/meter/reading/update', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getReadingConfig(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/meter/reading/get/all', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getBillsByUser(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/change/reading/water/electric/bills/list', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getAllAuditLogs(context, filter){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/audit/logs/list/all', filter)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error.response || error);
            })
        })
    },
    getAllUsers(context){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.get('/api/v1/auth/all/users')
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error.response || error);
            })
        })
    },
    getTotalOwners(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/owner/list/by/user', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error.response || error);
            })
        })
    },
   
    updateBill(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/change/reading/water/electric/update', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getAllUsers(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.get('/api/v1/auth/get/all/list', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getAllOwnerUsers(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.get('/api/v1/auth/get/all/owner/list', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getAllContractsList(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/list/contract/get/all/lists', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    createAdminUsers(context, request){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.post('/api/v1/auth/create/admin/users', request)
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
    getAdminDashboardStatistics(context, params){
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ sessionStorage.getItem('access_token')
        return new Promise((resolve, reject) => {
            axios.get('/api/admin/dashboard/statistics', { params })
            .then(response=>{
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
        })
    },
}
})